export enum PlanViewTypeEnum {
  Detail = 'detail'
}
